import React from "react";
import { languages } from "../../constants/languages";
import { withTheme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AttachmentIcon from "@material-ui/icons/Attachment";
import FileUploader from "react-firebase-file-uploader";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditPictureContainer from "./EditPictureContainer";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  getUploadErrorMessage,
  validateFileSize,
} from "../../util/uploadErrors";

class AttachmentsContainer extends React.Component {
  state = {
    attachments: [],
    attachmentsTemp: undefined,
    pictures: [],
    picturesTemp: undefined,
    errorMessage: "",
    isUploading: false,
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribe = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("attachments")
      .onSnapshot((querySnapshot) => {
        let attachments = [];
        querySnapshot.forEach((doc) => {
          let attachment = doc.data();
          attachment["id"] = doc.id;
          attachments.push(attachment);
        });
        this.setState({
          attachments: attachments.sort((a, b) => {
            if (a.num > b.num) {
              return 1;
            } else if (a.num < b.num) {
              return -1;
            } else {
              return 0;
            }
          }),
          attachmentsTemp: undefined,
        });
      });

    this.unsubscribe2 = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("pictures")
      .onSnapshot((querySnapshot) => {
        let pictures = [];
        querySnapshot.forEach((doc) => {
          let picture = doc.data();
          picture["id"] = doc.id;
          pictures.push(picture);
        });
        this.setState({
          pictures: pictures.sort((a, b) => a.num - b.num),
          picturesTemp: undefined,
        });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
    this.unsubscribe2();
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true,
      errorMessage: "",
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    let toUpdate = { errorMessage: getUploadErrorMessage(error, 5) };

    this.setState(toUpdate);
  };

  handleUploadSuccess = (filename) => {
    this.setState({ isUploading: false });

    const storageRef = this.getStorageRef();
    storageRef
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        const num =
          this.state.attachments.length === 0
            ? 0
            : (this.state.attachments[this.state.attachments.length - 1].num ||
                this.state.attachments.length - 1) + 1;
        let toUpdate = { url: url, filename: filename, num: num };
        let attachmentsRef = window.firebase
          .firestore()
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("attachments");

        let attachmentRef = attachmentsRef.doc();

        attachmentRef.set(toUpdate);
      });
  };

  getStorageRef = () => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        "attachments/" +
          this.props.user.uid +
          "/" +
          this.props.tournament[".key"]
      );
  };

  handleDelete = (attachmentId, type = "attachment") => {
    let attachmentsRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection(type === "picture" ? "pictures" : "attachments");

    let attachmentRef = attachmentsRef.doc(attachmentId);
    attachmentRef.delete();
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const attachments = this.state.attachments.slice();
    const [removed] = attachments.splice(result.source.index, 1);
    attachments.splice(result.destination.index, 0, removed);

    const db = window.firebase.firestore();
    let batch = db.batch();
    const attachmentsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("attachments");
    let attachmentsTemp = [];
    attachments.forEach((a, i) => {
      let attachment = attachments[i];
      attachment["num"] = i;
      attachmentsTemp.push(attachment);
      batch.update(attachmentsRef.doc(a.id), { num: i });
    });
    this.setState({ attachmentsTemp: attachmentsTemp });
    batch.commit().catch((error) => {
      console.log(error.message);
      this.setState({ attachmentsTemp: undefined });
    });
  };

  onDragEndPicture = (result) => {
    if (!result.destination) {
      return;
    }

    const pictures = this.state.pictures.slice();
    const [removed] = pictures.splice(result.source.index, 1);
    pictures.splice(result.destination.index, 0, removed);

    const db = window.firebase.firestore();
    let batch = db.batch();
    const picturesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("pictures");
    let picturesTemp = [];
    pictures.forEach((a, i) => {
      let picture = pictures[i];
      picture["num"] = i;
      picturesTemp.push(picture);
      batch.update(picturesRef.doc(a.id), { num: i });
    });
    this.setState({ picturesTemp: picturesTemp });
    batch.commit().catch((error) => {
      console.log(error.message);
      this.setState({ picturesTemp: undefined });
    });
  };

  render() {
    return (
      <div>
        <Typography variant="subtitle2" style={{ marginTop: 20 }}>
          {languages.attachments.attachments}
        </Typography>
        <Typography variant="caption">
          {languages.attachments.description}
        </Typography>

        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="attachmentDrop">
            {(provided, snapshot) => {
              return (
                <div
                  ref={provided.innerRef}
                  style={{
                    marginTop: 5,
                  }}
                >
                  {(this.state.attachmentsTemp || this.state.attachments).map(
                    (attachment, i) => (
                      <Draggable
                        key={attachment.id}
                        draggableId={attachment.id}
                        index={i}
                      >
                        {(provided, snapshot) => (
                          <div>
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <div style={{ paddingBottom: 3 }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    border: "1px solid lightgray",
                                    padding: 5,
                                    alignItems: "center",
                                    borderRadius: 5,
                                    background: "white",
                                  }}
                                >
                                  <Typography>{attachment.filename}</Typography>
                                  <IconButton
                                    aria-label="Change"
                                    onClick={() => {
                                      this.handleDelete(attachment.id);
                                    }}
                                    style={{ height: 30, width: 30 }}
                                  >
                                    <DeleteIcon
                                      style={{
                                        height: 20,
                                        width: 20,
                                        position: "absolute",
                                        top: 5,
                                      }}
                                    />
                                  </IconButton>
                                </div>
                              </div>
                            </div>
                            {provided.placeholder}
                          </div>
                        )}
                      </Draggable>
                    )
                  )}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>

        {this.state.isUploading && (
          <Typography>{languages.tournament.uploading}</Typography>
        )}
        {this.state.errorMessage && (
          <Typography style={{ color: "red" }}>{this.state.errorMessage}</Typography>
        )}
        <div>
          <FileUploader
            id="upload-attachment"
            style={{ display: "none" }}
            accept="media_type"
            name="attachmentUpload"
            storageRef={this.getStorageRef()}
            beforeUploadStart={(file) => {
              validateFileSize(file, 5);
            }}
            onUploadStart={this.handleUploadStart}
            onUploadError={(error) => {
              this.handleUploadError(error);
            }}
            onUploadSuccess={(fileName) => {
              this.handleUploadSuccess(fileName);
            }}
            onProgress={this.handleProgress}
          />
          <label htmlFor={"upload-attachment"}>
            <Button
              fullWidth
              variant="outlined"
              component="span"
              onClick={() => {}}
            >
              <AttachmentIcon
                style={{ height: 16, width: 16, marginRight: 5 }}
              />
              {languages.attachments.addAttachment}
            </Button>
          </label>
        </div>

        <Typography variant="subtitle2" style={{ marginTop: 20 }}>
          {languages.attachments.pictures}
        </Typography>
        <Typography variant="caption">
          {languages.attachments.descriptionPictures}
        </Typography>

        <DragDropContext onDragEnd={this.onDragEndPicture}>
          <Droppable droppableId="pictureDrop">
            {(provided, snapshot) => {
              return (
                <div
                  ref={provided.innerRef}
                  style={{
                    marginTop: 5,
                  }}
                >
                  {(this.state.picturesTemp || this.state.pictures).map(
                    (picture, i) => (
                      <Draggable
                        key={picture.id}
                        draggableId={picture.id}
                        index={i}
                      >
                        {(provided, snapshot) => (
                          <div>
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <div style={{ paddingBottom: 3 }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    border: "1px solid lightgray",
                                    padding: 5,
                                    alignItems: "center",
                                    borderRadius: 5,
                                    background: "white",
                                  }}
                                >
                                  <Typography>{picture.title}</Typography>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <EditPictureContainer
                                      tournament={this.props.tournament}
                                      user={this.props.user}
                                      userData={this.props.userData}
                                      userStatus={this.props.userStatus}
                                      tournamentStatus={
                                        this.props.tournamentStatus
                                      }
                                      picture={picture}
                                      pictures={this.state.pictures}
                                    />
                                    <IconButton
                                      aria-label="Change"
                                      onClick={() => {
                                        this.handleDelete(
                                          picture.id,
                                          "picture"
                                        );
                                      }}
                                      style={{ height: 30, width: 30 }}
                                    >
                                      <DeleteIcon
                                        style={{
                                          height: 20,
                                          width: 20,
                                          position: "absolute",
                                          top: 5,
                                        }}
                                      />
                                    </IconButton>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {provided.placeholder}
                          </div>
                        )}
                      </Draggable>
                    )
                  )}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>

        <EditPictureContainer
          tournament={this.props.tournament}
          user={this.props.user}
          userData={this.props.userData}
          userStatus={this.props.userStatus}
          tournamentStatus={this.props.tournamentStatus}
          pictures={this.state.pictures}
        />
      </div>
    );
  }
}

export default withTheme(AttachmentsContainer);
